// Feedback #511 — reusable "📝 Report" chip that any popup/window can drop
// into its header.  Fires the existing `open-report-issue` event that
// ReportIssueButton listens for; passes optional `popupTitle` so the modal
// can pre-fill the report with the popup's identity.
//
// Zero external dependencies — the chip stays lightweight so DraggablePopup
// doesn't grow a heavy import.
export default function ReportIssueChip ({ popupTitle, title }) {
  const label = title || 'Report an issue with this popup'
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        try {
          window.dispatchEvent(new CustomEvent('open-report-issue', {
            detail: { source: 'popup', popupTitle: popupTitle || document?.title || '' },
          }))
        } catch { /* Safari older versions — fall back to plain event */
          window.dispatchEvent(new Event('open-report-issue'))
        }
      }}
      title={label}
      aria-label={label}
      className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-purple-600 hover:bg-purple-50 rounded px-2 py-0.5 transition-colors"
    >
      <span aria-hidden="true">💬</span>
      <span className="hidden sm:inline">Report</span>
    </button>
  )
}
